import React from "react";
import { Field, reduxForm } from "redux-form";
import { Grid, Form, Button, Segment } from "semantic-ui-react";

class AddContactosForm extends React.Component {
  renderTextField = ({ input, meta: { touched, error }, ...others }) => (
    <Form.Input {...input} {...others} />
  );

  handleSaveModal = values => this.props.saveModal(values);

  render = () => {
    const { handleSubmit } = this.props;
    return (
      <Segment basic textAlign="center">
        <Grid columns="equal">
          <Grid.Column />
          <Grid.Column width={8}>
            <Form>
              <Form.Group widths="1">
                <Field
                  id="nombre"
                  name="nombre"
                  placeholder="Nombre"
                  component={this.renderTextField}
                />
                <Field
                  id="cargo"
                  name="cargo"
                  placeholder="Cargo"
                  component={this.renderTextField}
                />
              </Form.Group>
              <Form.Group>
                <Field
                  id="correo"
                  name="correo"
                  placeholder="Correo"
                  component={this.renderTextField}
                />
                <Field
                  id="telefono"
                  name="telefono"
                  placeholder="teléfono"
                  component={this.renderTextField}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Button
                  basic
                  negative
                  labelPosition="right"
                  icon="cancel"
                  content="Cancelar"
                  onClick={this.props.cancelModal}
                />
                <Button
                  basic
                  positive
                  labelPosition="right"
                  icon="checkmark"
                  content="Guardar"
                  onClick={handleSubmit(this.handleSaveModal)}
                />
              </Form.Group>
            </Form>
          </Grid.Column>
          <Grid.Column />
        </Grid>
      </Segment>
    );
  };
}

export default reduxForm({ form: "FormularioContacto" })(AddContactosForm);



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/colegioForm/contactosTabla/addContactos/AddContactosForm.jsx